module.exports = __webpack_public_path__ + "static/media/menu.fb234311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 300
// module chunks = 0